import {
  Accordion as AccordionCore,
  AccordionSummary as AccordionSummaryCore,
  Avatar as AvatarCore,
  Typography as TypographyCore,
  AccordionDetails as AccordionDetailsCore,
} from '@material-ui/core';

import * as lib from '~/dependencies';

const { css } = lib.StyledComponents;

export const ExpansibleContactsContainer = lib.styled.div`
    width: 100%;
    margin: 5px 0px 0px;

    .custom-urls-container {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .MuiAccordion-root:before {
            height: 0px !important;
        }
    }
`;

export const Accordion = lib.styled(AccordionCore)`
    border-color: #dadada;

    ${({ borderradius, border, bordercolor, backgroundcolor }: any) => {
      return css`
        border: ${border} !important;
        border-radius: ${borderradius} !important;
        ${bordercolor && ` border-color: ${bordercolor} !important`};
        ${backgroundcolor && `background-color: ${backgroundcolor} !important`};
      `;
    }}

    &.MuiPaper-elevation1 {
        box-shadow: unset !important;
    }
`;

// NOTE: The tool bar of active calls has height 38
export const AccordionSummary = lib.styled(AccordionSummaryCore)`
    min-height: unset !important; 
    max-height: 38px !important; 
    height: 38px !important; 
    padding-right: 4px;
    padding-left: 8px;
    border: 1px solid
    border-color: transparent;
    margin: 0;

    &.MuiAccordionSummary-root.Mui-expanded {
        min-height: unset !important; 
        height: 38px !important; ;
        max-height: 38px !important; 
    }
`;

export const Avatar = lib.styled(AvatarCore)`
    width: 24px !important;
    height: 24px !important;
    margin-right: 15px;
`;

// fontWeight: 900 !important;
export const Typography = lib.styled(TypographyCore)`
    font-size: 12px !important;
    color: #989898;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AccordionDetails = lib.styled(AccordionDetailsCore)`
    display: flex;
    flex-direction: column;
    padding: 0px 5px 0px 3px !important;

    .MuiPaginationItem-root {
        color: #7c7c7c !important;
    }
`;

export const PaginationContainer = lib.styled.div`
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    justify-content: center;
`;
